// extracted by mini-css-extract-plugin
module.exports = {"settingsBlock":"main_settingsBlock__1h2el"};